import RouteURL from '~routes'

export const MENU_ITEMS = [
  { label: 'Explore', url: RouteURL.HOMEPAGE },
  { label: 'Legends', url: RouteURL.LEGENDS },
]
